"use client";

import { c as _c } from "react/compiler-runtime";
import { TestFlaskIcon } from "@navikt/aksel-icons";
import { Box, Button, Modal, Radio, RadioGroup } from "@navikt/ds-react";
import { useRouter } from "next/navigation";
import { useState } from "react";
import { DEFAULT_DEMO_SCENARIO, DEMO_SCENARIO_COOKIE, type DemoScenario, type DemoScenarioOption, parseDemoScenario } from "@/common/demoScenario";
export function DemoScenarioPicker(t0) {
  const $ = _c(29);
  const {
    scenarios
  } = t0;
  const router = useRouter();
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(DEFAULT_DEMO_SCENARIO);
  let t1;
  if ($[0] !== scenarios) {
    t1 = function handleOpen() {
      const cookieValue = document.cookie.split(";").map(_temp).find(_temp2)?.split("=").slice(1).join("=");
      const parsed = parseDemoScenario(cookieValue);
      const currentScenario = scenarios.some(scenario => scenario.value === parsed) ? parsed : scenarios.some(_temp3) ? DEFAULT_DEMO_SCENARIO : scenarios[0]?.value ?? DEFAULT_DEMO_SCENARIO;
      setSelected(currentScenario);
      setOpen(true);
    };
    $[0] = scenarios;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleOpen = t1;
  let t2;
  if ($[2] !== router || $[3] !== selected) {
    t2 = function handleApply() {
      const secure = window.location.protocol === "https:" ? "; Secure" : "";
      document.cookie = `${DEMO_SCENARIO_COOKIE}=${selected}; path=/; SameSite=Lax${secure}`;
      router.refresh();
      setOpen(false);
    };
    $[2] = router;
    $[3] = selected;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleApply = t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      bottom: "var(--ax-space-24)",
      right: "var(--ax-space-24)",
      zIndex: 100
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <TestFlaskIcon aria-hidden={true} />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== handleOpen) {
    t5 = <Box position="fixed" style={t3}><Button variant="primary" size="medium" icon={t4} onClick={handleOpen}>Demo</Button></Box>;
    $[7] = handleOpen;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => setOpen(false);
    t7 = {
      heading: "Demo-scenario",
      closeButton: true
    };
    $[9] = t6;
    $[10] = t7;
  } else {
    t6 = $[9];
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = value => setSelected(parseDemoScenario(value));
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== scenarios) {
    t9 = scenarios.map(_temp4);
    $[12] = scenarios;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== selected || $[15] !== t9) {
    t10 = <Modal.Body><RadioGroup legend="Velg scenario" value={selected} onChange={t8}>{t9}</RadioGroup></Modal.Body>;
    $[14] = selected;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== handleApply) {
    t11 = <Button onClick={handleApply}>Bruk scenario</Button>;
    $[17] = handleApply;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Button variant="tertiary" onClick={() => setOpen(false)}>Avbryt</Button>;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t11) {
    t13 = <Modal.Footer>{t11}{t12}</Modal.Footer>;
    $[20] = t11;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== open || $[23] !== t10 || $[24] !== t13) {
    t14 = <Modal open={open} onClose={t6} header={t7} width="small">{t10}{t13}</Modal>;
    $[22] = open;
    $[23] = t10;
    $[24] = t13;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== t14 || $[27] !== t5) {
    t15 = <>{t5}{t14}</>;
    $[26] = t14;
    $[27] = t5;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  return t15;
}
function _temp4(t0) {
  const {
    value: value_0,
    label
  } = t0;
  return <Radio key={value_0} value={value_0}>{label}</Radio>;
}
function _temp3(s) {
  return s.value === DEFAULT_DEMO_SCENARIO;
}
function _temp2(cookie) {
  return cookie.startsWith(`${DEMO_SCENARIO_COOKIE}=`);
}
function _temp(c) {
  return c.trim();
}